import { Result } from 'antd';
import { useTranslation } from 'react-i18next';

export const NoAccess = (): JSX.Element => {
  const { t } = useTranslation();

  return <Result status='403' title={t('noAccess.title')} subTitle={t('noAccess.description')} />;
};
